import { create } from 'zustand';

// A simple store for the generic sample-ui.yaml page.
// It doesn't need much, just a place to hold state if needed.
export const useSampleUIStore = create((set) => ({
  // Add any state needed by sample-ui.yaml here in the future
  someValue: 'hello world',
  setSomeValue: (value: string) => set({ someValue: value }),
})); 